import { render } from "./VImage.vue?vue&type=template&id=7083de33"
import script from "./VImage.vue?vue&type=script&lang=js"
export * from "./VImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__